import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import {
  CONFIGURATION_ROOT_NAMES,
  CONFIGURATION_ROUTE_PREFIXES,
  CONFIGURATION_WELCOME_ROUTE,
} from '../../shared/constants/configuration-roots';

interface MenuOption {
  id: string;
  description: string;
  pathIcon: any;
  route: string;
  ordem: number;
  hasChildren: boolean;
  children: MenuOption[];
}
interface SubFuncionalidade {
  id: string;
  nome: string;
  url: string;
  ordem: number;
  restricoes: any[];
  subFuncionalidades: any[];
}

interface Funcionalidade {
  id: string;
  nome: string;
  url: string;
  ordem: number;
  restricoes: any[];
  subFuncionalidades: SubFuncionalidade[];
}

interface PermissaoPerfil {
  funcionalidade: Funcionalidade;
  restricoes: any[];
}

interface ProfileUserConfig {
  id: string;
  nome: string;
  criadoEm: string;
  status: boolean;
  master: boolean;
  admin: boolean;
  permissaoPerfis: PermissaoPerfil[];
}
const profileUserConfig: ProfileUserConfig = {
  id: "fe13d0f4-84f7-49d7-8745-bcee4b5dc214",
  nome: "Teste",
  criadoEm: "2025-08-21T13:14:54.061307Z",
  status: true,
  master: false,
  admin: true,
  permissaoPerfis: [
    {
      funcionalidade: {
        id: "155af598-b8f6-4c66-bd7f-6bc214113365",
        nome: "Configurações",
        url: "",
        ordem: 6,
        restricoes: [],
        subFuncionalidades: [
          {
            id: "9495d28a-3e45-408d-bb31-788d72a3da25",
            nome: "Calendário de feriados",
            url: "/feriados",
            ordem: 1,
            restricoes: [],
            subFuncionalidades: [],
          },
          {
            id: "9495d28a-3e45-408d-bb31-788d72a3da26",
            nome: "Notificações",
            url: "/contrato-notificacao",
            ordem: 2,
            restricoes: [],
            subFuncionalidades: [],
          },
        ],
      },
      restricoes: [],
    },
  ],
};
@Injectable({
  providedIn: 'root',
})
export class SidebarService {
  constructor(private sanitizer: DomSanitizer, private http: HttpClient) {}

  getMenuOptions(apiData: any): MenuOption[] {
    const menuOptions: MenuOption[] = [];

    const profileUser = apiData.profileUser;

    if (!profileUser || !profileUser.permissaoPerfis) {
      return menuOptions;
    }
    // Process each 'funcionalidade' in permissaoPerfis
    profileUser.permissaoPerfis.forEach((permissaoPerfil: any) => {
      const funcionalidade = permissaoPerfil.funcionalidade;
      // Create the main menu item with recursive children loading
    if (!CONFIGURATION_ROOT_NAMES.includes(funcionalidade.nome)) {
      const menuOption: MenuOption = {
        id: funcionalidade.id,
        description: funcionalidade.nome,
        ordem: funcionalidade.ordem,
        pathIcon: this.getSafeUrl(this.getIconPath(funcionalidade.nome)),
        route: funcionalidade.url || './#',
        hasChildren:
          funcionalidade.subFuncionalidades &&
          funcionalidade.subFuncionalidades.length > 0,
        children: this.mapSubFuncionalidades(funcionalidade.subFuncionalidades),
      };

      menuOptions.push(menuOption);
    }
    });

    // Sort the main menu options by 'ordem'
    return menuOptions.sort((a, b) => a.ordem - b.ordem);
  }

  getMenuConfiuracaoOptions(apiData?: any): MenuOption[] {
    const menuOptions: MenuOption[] = [];

    const profileUser = profileUserConfig;

    if (!profileUser || !profileUser.permissaoPerfis) {
      return menuOptions;
    }
    // Process each 'funcionalidade' in permissaoPerfis
    profileUser.permissaoPerfis.forEach((permissaoPerfil: any) => {
      const funcionalidade = permissaoPerfil.funcionalidade;

      // Create the main menu item with recursive children loading
      const menuOption: MenuOption = {
        id: funcionalidade.id,
        description: funcionalidade.nome,
        ordem: funcionalidade.ordem,
        pathIcon: this.getSafeUrl(this.getIconPath(funcionalidade.nome)),
        route: funcionalidade.url || './#',
        hasChildren:
          funcionalidade.subFuncionalidades &&
          funcionalidade.subFuncionalidades.length > 0,
        children: this.mapSubFuncionalidades(funcionalidade.subFuncionalidades),
      };

      menuOptions.push(menuOption);
    });

    // Sort the main menu options by 'ordem'
    return menuOptions.sort((a, b) => a.ordem - b.ordem);
  }

  getConfigurationWelcomeRoute(): string {
    return CONFIGURATION_WELCOME_ROUTE;
  }

  isConfigurationRoute(route: string): boolean {
    return CONFIGURATION_ROUTE_PREFIXES.some((prefix) =>
      route.startsWith(prefix)
    );
  }

  private mapSubFuncionalidades(subFuncionalidades: any[]): MenuOption[] {
    return subFuncionalidades
      .sort((a: any, b: any) => a.ordem - b.ordem) // Sort by 'ordem'
      .map((subFunc: any) => ({
        id: subFunc.id,
        description: subFunc.nome,
        ordem: subFunc.ordem,
        pathIcon: '',
        route: subFunc.url,
        hasChildren:
          subFunc.subFuncionalidades && subFunc.subFuncionalidades.length > 0,
        children: subFunc.subFuncionalidades
          ? this.mapSubFuncionalidades(subFunc.subFuncionalidades)
          : [],
      }));
  }

  getIconPath(description: string): string {
    const iconMap: { [key: string]: string } = {
      'Gestão de usuários': 'assets/create-user/svgs/user_conf.svg',
      'Cadastros auxiliares': 'assets/create-user/svgs/cadastro.svg',
      Configurando: 'assets/create-user/svgs/vector.svg',
      'Configurações': 'assets/create-user/svgs/vector.svg',
      Cadastro: 'assets/create-user/svgs/conjunto.svg',
      Administração: 'assets/create-user/svgs/contrato.svg',
      'Gestão de Contratos': 'assets/create-user/svgs/gestao-de-contrato.svg',
      'Feriados': 'assets/create-user/svgs/feriado.svg',
      'Aferições': 'assets/create-user/svgs/afericoes.svg',
      Obras: 'assets/create-user/svgs/obras.svg',
      Contrato: 'assets/create-user/svgs/contrato.svg',
    };

    return iconMap[description] || 'assets/create-user/svgs/conjunto.svg';
  }

  getSafeUrl(path: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(path);
  }
}
